// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Your web app's Firebase configuration
// Using the same Firebase project as ag_grid for consistency
const firebaseConfig = {
  apiKey: "AIzaSyAJfU1MFLpwUFlHfC9_RRHNGBZg99kAAMk",
  authDomain: "workflowpad.firebaseapp.com",
  projectId: "workflowpad",
  storageBucket: "workflowpad.firebasestorage.app",
  messagingSenderId: "1023557390544",
  appId: "1:1023557390544:web:cc99dbceeb0587bd858ed5",
  measurementId: "G-49CKPRVJWY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app, 'us-central1');

// Connect to Functions emulator in development - only once
let emulatorConnected = false;
if (process.env.NODE_ENV === 'development' && !emulatorConnected) {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    emulatorConnected = true;
    console.log('Connected to Firebase Functions emulator at localhost:5001');
  } catch (error) {
    console.warn('Could not connect to Firebase Functions emulator:', error);
    console.log('Make sure to start the emulator with: firebase emulators:start --only functions');
  }
}

export { app, analytics, db, auth, functions };

/**
 * Sign into Firebase using Clerk's custom token
 * This function should be called after the user is authenticated with Clerk
 */
export const signIntoFirebaseWithClerk = async (getToken: (options?: any) => Promise<string | null>) => {
  try {
    const token = await getToken({ template: 'integration_firebase' });
    
    if (!token) {
      throw new Error('No Firebase token received from Clerk');
    }

    // Sign in the user with Clerk token
    const userCredentials = await signInWithCustomToken(auth, token);
    
    return userCredentials.user;
  } catch (error) {
    console.error('Error signing into Firebase with Clerk:', error);
    throw error;
  }
}; 